import {
  GET_PAY_PER_VIEW,
  CREATE_NEW_PAY_PER_VIEW,
  EDIT_PAY_PER_VIEW,
  OPEN_PAY_PER_VIEW_DIALOG,
  CLOSE_PAY_PER_VIEW_DIALOG,
  DELETE_PAY_PER_VIEW,
} from "./payPerView.type";

const initialState = {
  payPerView: [],
  total: 0,
  currentPage: 1,
  totalPages: 1,
  dialog: false,
  dialogData: null,
};

const payPerViewReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PAY_PER_VIEW:
      return {
        ...state,
        payPerView: action.payload.payPerViews || action.payload || [],
        total: action.payload.total || 0,
        currentPage: action.payload.currentPage || 1,
        totalPages: action.payload.totalPages || 1,
      };

    case CREATE_NEW_PAY_PER_VIEW:
      const data = [...state.payPerView];
      data.unshift(action.payload);
      return {
        ...state,
        payPerView: data,
        total: state.total + 1,
      };

    case EDIT_PAY_PER_VIEW:
      return {
        ...state,
        payPerView: state.payPerView.map((payPerView) => {
          if (payPerView._id === action.payload.id) return action.payload.data;
          else return payPerView;
        }),
      };

    case DELETE_PAY_PER_VIEW:
      return {
        ...state,
        payPerView: state.payPerView.filter(
          (payPerView) => payPerView._id !== action.payload
        ),
        total: Math.max(0, state.total - 1),
      };

    case OPEN_PAY_PER_VIEW_DIALOG:
      return {
        ...state,
        dialog: true,
        dialogData: action.payload || null,
      };

    case CLOSE_PAY_PER_VIEW_DIALOG:
      return {
        ...state,
        dialog: false,
        dialogData: null,
      };

    default:
      return state;
  }
};

export default payPerViewReducer;
